import React from 'react';
import { TraksConsumer } from './traks';
import { connect } from 'react-redux';
import API from './API';
import Me from './Me';
import { current_site_id } from './Site';

const mk_requestor_object = (lang) => {
	const do_request = (action, args, callback) => {
		if (!args) args = {};
		args = {
			...args,
			site: current_site_id,
			dryrun: args.dryrun ? 1 : 0,
			from: window.location.href,
		};
		if (lang) args.lang = lang;
		API.post("/a/ua" + action, args, (response, status) => {
			if (status === 400) {
				if (callback) callback({code: response.ErrorCode});
			} else if (status === 200) {
				if (response) {
					if (response.GoTo) {
						window.location.href = response.GoTo;
					} else {
						Me.set(response.Me);
						if (callback) callback(null);
					}
				} else {
					if (callback) callback(null);
				}
			}
		});
	}

	return {
		login: (auth_email, auth_password, callback) => {
			do_request("/login", {auth_email, auth_password}, callback);
		},

		login_with_jwt: (token, groupGameId, groupGameInviteKey, callback) => {
			do_request("/login_with_jwt", {
                jwt: token,
                groupGameId: groupGameId,
                groupGameInviteKey: groupGameInviteKey 
            }, callback);
		},

		signup: (email, password, screen_name, dryrun, callback) => {
			do_request("/signup", {email, password, screen_name, dryrun}, callback);
		},

		set_email_password: (auth_password, new_email, new_password, dryrun, callback) => {
			var args = {auth_password, dryrun};
			if (new_email) args.new_email = new_email;
			if (new_password) args.new_password = new_password;
			do_request("/set_email_password", args, callback);
		},

		set_email_and_join_game: (new_email, game_id, invite_key, payload, callback) => {
			do_request("/set_email_and_join_game", {new_email, game_id, invite_key, payload}, callback);
		},

		provide_email_and_accept_all_terms: (email, callback) => {
			do_request("/provide_email_and_accept_all_terms", {email}, callback);
		},

		set_password_with_token: (auth_token, auth_email, new_password, dryrun, callback) => {
			var args = {auth_token, auth_email, new_password, dryrun};
			do_request("/set_email_password", args, callback);
		},

		delete_account: (confirmation, dryrun, callback) => {
			do_request("/delete_account", {confirmation, dryrun}, callback);
		},

		oauth: {
			login: {
				fb: () => { do_request("/oauth/login/fb"); },
				twtr: () => { do_request("/oauth/login/twtr"); },
			},
			login_and_join_game: {
				fb: (join_game_id, invite_key, payload) => { do_request("/oauth/login/fb", {join_game_id, invite_key, payload}); },
				twtr: (join_game_id, invite_key, payload) => { do_request("/oauth/login/twtr", {join_game_id, invite_key, payload}); },
			},
			attach: {
				fb: (auth_password, callback) => { do_request("/oauth/attach/fb", {auth_password}, callback); },
				twtr: (auth_password, callback) => { do_request("/oauth/attach/twtr", {auth_password}, callback); },
			},
			detach: {
				fb: (auth_password, callback) => { do_request("/oauth/detach/fb", {auth_password}, callback); },
				twtr: (auth_password, callback) => { do_request("/oauth/detach/twtr", {auth_password}, callback); },
			},
		},

		remove_email: (auth_password, dryrun, callback) => {
			do_request("/remove_email", {auth_password, dryrun}, callback);
		},
	};

};

const AUAContainerInner = connect(
	(state) => ({
		me: state.me,
		auth: state.auth,
	})
)((props) => {
	var aua = {
		me: props.me,
		auth: props.auth,
		lang: props.lang,
	};
	aua.request = mk_requestor_object(props.lang);
	const children = React.Children.map(props.children, child => React.cloneElement(child, {...props, aua}));
	return <React.Fragment>{children}</React.Fragment>;
});

const AUAContainer = (props) => <TraksConsumer><AUAContainerInner {...props}>{props.children}</AUAContainerInner></TraksConsumer>

/* NOTE when using AUARequest, lang is not known; if your AUA requests do
 * anything that would like to know the language (like sending emails), it'll
 * fall back to a default */
const AUARequest = mk_requestor_object();

export {
	AUAContainer,
	AUARequest
}



// WEBPACK FOOTER //
// ./src/AUA.js